import React from "react";

function Leave() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M2.5 12.143c0-4.478 0-6.717 1.391-8.109 1.391-1.39 3.63-1.39 8.109-1.39 4.478 0 6.718 0 8.109 1.39 1.391 1.392 1.391 3.63 1.391 8.11 0 4.477 0 6.717-1.391 8.108-1.392 1.391-3.63 1.391-8.109 1.391-4.478 0-6.718 0-8.109-1.391S2.5 16.622 2.5 12.143z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M2.5 9.143h19"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M13 13.143h4M13 17.143h2"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7 6.143h.009M11 6.143h.009"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9 9.143v12.5"
      ></path>
    </svg>
  );
}

export default Leave;
